import React from 'react';
import { Button } from '@material-ui/core';
import { PlayArrow } from '@material-ui/icons';
import { useEnabledStart } from '../hooks';

const EnabledStart = () => {
  const { enabledStartState, handleEnabledStart } = useEnabledStart();

  return (
    <Button
      variant="outlined"
      disabled={enabledStartState.loading}
      onClick={handleEnabledStart}
      endIcon={<PlayArrow />}
    >
      Enabled start
    </Button>
  );
};

export default EnabledStart;
